import styled from 'styled-components';

import bgSrc from '../../assets/images/education/comp_call_bg.jpg';

export const Root = styled.div`
  position: relative;
  width: 100%;
`;

export const ImageContainer = styled.div`
  width: 100%;
  background-image: url(${bgSrc});
  background-repeat: no-repeat;

  @media (width < 1024px) {
    height: 469px;
    background-position-x: 90%;
    background-size: auto 100%;
  }

  @media (width >= 1024px) {
    display: flex;
    align-items: center;
    height: 733px;
    background-size: cover;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  @media (width < 1024px) {
    padding: 17px 24px;
  }

  @media (width >= 1024px) {
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 0;
    width: 733px;
    height: 396px;
    padding-left: 126px;
    padding-right: 46px;
    background-color: #fff;
    transform: translateY(-50%);
  }
`;

export const LogoImage = styled.img`
  flex-shrink: 0;
  width: 295px;
`;

export const Title = styled.h4`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const Desc = styled.p`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;
